'use client';
import React from 'react';

const AboutHero: React.FC = () => {
    return (
        <section className="relative py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div>
                        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
                            About Junction Integrated Logistics
                        </h1>
                        <p className="text-lg text-gray-600 mb-8">
                            We are a dedicated group of logistics professionals with decades of industry experience. 
                            We got our start as a small drayage provider in the LA basin, and through customer obsession, 
                            competitive rates, and relentless investment in technology we&apos;ve grown to the a top 5 LA 
                            drayage provider with a national reach.
                        </p>
                        <div className="space-y-4">
                            <div className="flex items-center space-x-3">
                                <div className="h-6 w-6 rounded-full bg-[#29abe2] bg-opacity-20 flex items-center justify-center">
                                    <svg className="h-4 w-4 text-[#29abe2]" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <span className="text-gray-700">National capacity via trusted partners at all major ports and rails</span>
                            </div>                        
                            <div className="flex items-center space-x-3">
                                <div className="h-6 w-6 rounded-full bg-[#29abe2] bg-opacity-20 flex items-center justify-center">
                                    <svg className="h-4 w-4 text-[#29abe2]" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <span className="text-gray-700">300+ Drivers Nationwide</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <div className="h-6 w-6 rounded-full bg-[#29abe2] bg-opacity-20 flex items-center justify-center">
                                    <svg className="h-4 w-4 text-[#29abe2]" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <span className="text-gray-700">1500+ Chassis Available</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <div className="h-6 w-6 rounded-full bg-[#29abe2] bg-opacity-20 flex items-center justify-center">
                                    <svg className="h-4 w-4 text-[#29abe2]" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <span className="text-gray-700">$9B+ Cargo Moved Yearly</span>
                            </div>
                        </div>
                    </div>

                    <div className="relative h-[500px] rounded-2xl overflow-hidden">
                        <img
                            src="/images/about-main.jpg"
                            alt="About Junction Integrated Logistics"
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutHero; 